import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Box } from "../Box";
import { Shortcut } from "../Menu";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
import { TooltipTitle } from "./TooltipContent";
import { getKeyboardShortcutString } from "./getKeyboardShortcutString";
/**
 * Return true if the browser reports the OS as not Windows.
 */

function useIsAppleOs() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAppleOs = _useState2[0],
      setIsAppleOs = _useState2[1];

  useEffect(function () {
    var _window;

    setIsAppleOs(!((_window = window) === null || _window === void 0 ? void 0 : _window.navigator.platform.startsWith('Win')));
  }, []);
  return isAppleOs;
}

export var TooltipTitleWithShortcut = function TooltipTitleWithShortcut(_ref) {
  var shortcut = _ref.shortcut,
      keys = _ref.keys,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["shortcut", "keys", "children"]);

  var isAppleOs = useIsAppleOs();
  return /*#__PURE__*/React.createElement(Container, other, /*#__PURE__*/React.createElement(TooltipTitle, null, children), /*#__PURE__*/React.createElement(Box, {
    width: 8
  }), /*#__PURE__*/React.createElement(Shortcut, {
    compressed: true
  }, keys ? getKeyboardShortcutString(keys, isAppleOs) : shortcut));
};
var Container = styled(Box).withConfig({
  displayName: "TooltipTitleWithShortcut__Container",
  componentId: "vapor__sc-1h3pplg-0"
})(["display:flex;align-items:center;margin-right:calc(", " * -1);max-height:", ";white-space:nowrap;"], theme.spaces[6], theme.spaces[16]);